import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'platform',
})
export class LoadingService {
  private _activeRequests = 0;
  private readonly _isLoading = new BehaviorSubject<boolean>(false);
  public readonly isLoading = this._isLoading.asObservable();

  incrementRequests(): void {
    this._activeRequests++;
    if (!this._isLoading.getValue()) {
      this.show();
    }
  }

  decrementRequests(): void {
    if (this._activeRequests > 0) {
      this._activeRequests--;
    }

    if (this._activeRequests === 0 && this._isLoading.getValue()) {
      this.hide();
    }
  }

  private show() {
    this._isLoading.next(true);
  }

  private hide() {
    this._isLoading.next(false);
  }
}
